export default function printError(err) {
  console.log('Error occurred!', JSON.stringify(err));
}
